import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  sectionContainerStyle: (isRecommended, theme) => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderColor: theme.colors.activeColor,
    ...Platform.select({
      ios: {
        shadowColor: 'rgba(0, 0, 0, 0.16)',
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowRadius: 6,
        shadowOpacity: 1,
      },
      android: {
        elevation: 2,
      },
    }),
    borderRadius: 6,
    ...(isRecommended ? { borderWidth: 1, marginTop: 32, borderTopLeftRadius: 0 } : {}),
  }),
  recommendedBadageContainer: {
    left: -1,
    height: 33,
    top: -32,
    position: 'absolute',
  },
});
